import 'angular';
import 'special-guest';
import {createRootModule} from 'utils/module-registry';

let rootModule = createRootModule('special-guest');
rootModule.config(config);

function config($compileProvider) {
  if(__BUILD__) { $compileProvider.debugInfoEnabled(false) } // Perf
}

document.body.innerHTML = '<special-guest></special-guest>';
angular.bootstrap(document, ['special-guest'], {strictDi:true});



/** WEBPACK FOOTER **
 ** ./index.js
 **/